// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1vpuA","noInteraction":"EventWrapper_noInteraction__27mfD"};